import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IGiangVienReducer } from "../../reducer-model/category/IGiangVienReducer";
import { IGiangVienActionTypes } from "../../action-types/category/IGiangVienActions";

const initState: IGiangVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  giangViens: [],
};

export const giangVienReducer = (
  state: IGiangVienReducer = initState,
  action: IGiangVienActionTypes
): IGiangVienReducer => {
  switch (action.type) {
    case "GIANG_VIEN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "GIANG_VIEN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        giangViens: action.payload,
      };
    case "GIANG_VIEN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GIANG_VIEN_SHOW_EDIT_MODAL":
      return {
        ...state,
        // isShowEditModal: true,
        giangVienEditing: action.payload,
      };
    case "GIANG_VIEN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        // isShowEditModal: false,
      };
    case "GIANG_VIEN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "GIANG_VIEN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        // isShowEditModal:false
      };
    case "GIANG_VIEN_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GIANG_VIEN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "GIANG_VIEN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "GIANG_VIEN_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
